import backofficeService from './backoffice';
import { brandRequestConfig } from '@/modules/Brand/requestBrand';

const load = async (path, config = {}) => {
  const response = await backofficeService.Api().get(path, config);
  const data = (response && response.data && (response.data.data || response.data)) || {};
  const publishableKey = data.publishableKey || data.key || '';
  if (!publishableKey) throw new Error('Stripe payment setup is unavailable for this billing account.');
  return { ...data, publishableKey };
};

export default {
  getSignupConfig(currentBrand) { return load('signup/stripe-config', brandRequestConfig(currentBrand)); },
  getOrganizationConfig() { return load('stripe/config'); },
};
